import React, { useState } from 'react';
import Link from 'next/link';
import { useAppSelector } from '@/lib/redux/hooks';
import DrawerItem from './DrawerItem';
import { MdClose } from 'react-icons/md';

// Define the props the component will accept
interface CartDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const CartDrawer: React.FC<CartDrawerProps> = ({ isOpen, onClose }) => {
  const { items } = useAppSelector((state) => state.cart);
  const total = items.reduce(
    (acc, curr) => acc + curr.price * curr.quantity,
    0
  );
  return (
    <>
      {/* The dark overlay */}
      <div
        className={`cart-overlay ${isOpen ? 'is-visible' : ''}`}
        onClick={onClose}
      />

      {/* The drawer panel */}
      <div className={`mobile-cart ${isOpen ? 'is-open' : ''}`}>
        <div className="dropdownmenu-wrapper">
          <div className="dropdown-cart-header">
            <span>Shopping Cart</span>
            <button className="btn-close" onClick={onClose} aria-label="Close">
              <MdClose />
            </button>
          </div>

          <div className="dropdown-cart-products">
            {/* --- Start of a Static Product Example --- */}

            {items?.map((product: any) => (
              <DrawerItem key={product?.id} product={product} />
            ))}
          </div>

          <div className="dropdown-cart-total">
            <span>SUBTOTAL:</span>
            <span className="cart-total-price">৳{total.toFixed(2)}</span>
          </div>

          <div className="dropdown-cart-action">
            <Link
              href="/cart"
              className="trk-btn trk-btn--outline w-100"
              onClick={onClose}
            >
              View Cart
            </Link>
            <Link
              href="/checkout"
              className="trk-btn trk-btn--primary"
              onClick={onClose}
            >
              Checkout
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default CartDrawer;
